import { Flex, useScreenSize } from '@banhala/ui-kit';
import React, { useMemo } from 'react';

const HORIZONTAL_PADDING = 16;
const PHOTO_BOX_GAP = 4;

export const ReviewSummarySkeleton = () => {
  const { width: screenWidth } = useScreenSize();

  const photoBoxSize = useMemo(() => {
    return (screenWidth - HORIZONTAL_PADDING * 2 - PHOTO_BOX_GAP * 3) / 4;
  }, [screenWidth]);
  return (
    <Flex>
      <Flex.Row
        alignItems={'center'}
        justifyContent={'space-between'}
        padding={{ vertical: 24, horizontal: HORIZONTAL_PADDING }}
      >
        <Flex
          width={200}
          height={26}
          backgroundColor={'bg_tertiary'}
          borderRadius={4}
        />
        <></>
      </Flex.Row>
      <Flex.Row
        padding={{ horizontal: HORIZONTAL_PADDING }}
        gap={PHOTO_BOX_GAP}
      >
        <Flex
          backgroundColor={'bg_tertiary'}
          borderRadius={4}
          width={photoBoxSize}
          height={photoBoxSize}
        ></Flex>
        <Flex
          backgroundColor={'bg_tertiary'}
          borderRadius={4}
          width={photoBoxSize}
          height={photoBoxSize}
        ></Flex>
        <Flex
          backgroundColor={'bg_tertiary'}
          borderRadius={4}
          width={photoBoxSize}
          height={photoBoxSize}
        ></Flex>
        <Flex
          backgroundColor={'bg_tertiary'}
          borderRadius={4}
          width={photoBoxSize}
          height={photoBoxSize}
        ></Flex>
      </Flex.Row>
      <Flex gap={12} padding={{ top: 16, horizontal: HORIZONTAL_PADDING }}>
        <Flex height={20} backgroundColor={'bg_tertiary'}></Flex>
        <Flex height={20} backgroundColor={'bg_tertiary'}></Flex>
        <Flex height={20} backgroundColor={'bg_tertiary'}></Flex>
      </Flex>
    </Flex>
  );
};
